
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 3.25c.026-.703.273-1.29.742-1.758C1.211 1.023 1.797.776 2.5.75H15c.703.026 1.29.273 1.758.742.469.469.716 1.055.742 1.758v12.5c-.026.703-.273 1.29-.742 1.758-.469.469-1.055.716-1.758.742H2.5c-.703-.026-1.29-.273-1.758-.742C.273 17.039.026 16.453 0 15.75V3.25zm3.75 7.5c.365 0 .664-.117.898-.352.235-.234.352-.533.352-.898s-.117-.664-.352-.898c-.234-.235-.533-.352-.898-.352s-.664.117-.898.352c-.235.234-.352.533-.352.898s.117.664.352.898c.234.235.533.352.898.352zm1.25-5c0-.365-.117-.664-.352-.898-.234-.235-.533-.352-.898-.352s-.664.117-.898.352c-.235.234-.352.533-.352.898s.117.664.352.898c.234.235.533.352.898.352s.664-.117.898-.352C4.883 6.414 5 6.115 5 5.75zM3.75 14.5c.365 0 .664-.117.898-.352.235-.234.352-.533.352-.898s-.117-.664-.352-.898C4.414 12.117 4.115 12 3.75 12s-.664.117-.898.352c-.235.234-.352.533-.352.898s.117.664.352.898c.234.235.533.352.898.352zM7.5 4.812c-.573.053-.885.365-.938.938.053.573.365.885.938.938h6.25c.573-.053.885-.365.938-.938-.053-.573-.365-.885-.938-.938H7.5zm0 3.75c-.573.053-.885.365-.938.938.053.573.365.885.938.938h6.25c.573-.053.885-.365.938-.938-.053-.573-.365-.885-.938-.938H7.5zm0 3.75c-.573.053-.885.365-.938.938.053.573.365.885.938.938h6.25c.573-.053.885-.365.938-.938-.053-.573-.365-.885-.938-.938H7.5z","fill":"#93C"}})])
          )
        }
      }
    